/**
 * AdvertisingPlatform
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* A mapping between an El Toro creative ID and a StackAdapt campaign ad ID
*/
export class V3StackAdaptCreativeMapping {
    /**
    * El Toro creative ID
    */
    'internalCreativeId'?: string;
    /**
    * StackAdapt campaign ad ID
    */
    'externalCampaignAdId'?: string;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "internalCreativeId",
            "baseName": "internal_creative_id",
            "type": "string",
            "format": ""
        },
        {
            "name": "externalCampaignAdId",
            "baseName": "external_campaign_ad_id",
            "type": "string",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return V3StackAdaptCreativeMapping.attributeTypeMap;
    }

    public constructor() {
    }
}

